var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtLiniePunct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.25,
    y1: 41,
    x2: 56.25,
    y2: 28,
    stroke: "black",
    strokeWidth: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56.25,
    y1: 14,
    x2: 56.25,
    y2: 1,
    stroke: "black",
    strokeWidth: 3.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 39.25,
    x2: 73,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 39.25,
    x2: 105,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: 39.25,
    x2: 86,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56.25,
    y1: 24.5,
    x2: 56.25,
    y2: 17.5,
    stroke: "black",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtLiniePunct);
export default __webpack_public_path__ + "static/media/colt_linie_punct.0b972282958978245465e5b103c4047a.svg";
export { ForwardRef as ReactComponent };